import { AutocompleteOption } from '@cp/ds/src/components/form';
import { LocationSuggestion } from '@common/model/location/locationSuggestion';

export interface IAddressOption extends AutocompleteOption {
  location?: string;
  cityFiasId?: string;
  cityLabel?: string;
}

export const toAddressOption = (s: LocationSuggestion): IAddressOption => ({
  value: s.value,
  label: s.value,
  cityLabel: s.cityLabel,
  location: s.location,
  cityFiasId: s.city_fias_id,
});
